// standbyAnalyticsCore.ts — canonical shared core (SQR-16001). Keep identical in SMF + SMC.
export const STANDBY_USER_TYPES = [
  'customer',
  'barber',
  'shop',
  'brand',
  'brand_as_shop',
  'operator',
] as const;
export type StandbyUserType = (typeof STANDBY_USER_TYPES)[number];

export const STANDBY_APPS = [
  'squire-mobile-flagship',
  'squire-mobile-commander',
  'squire-api',
] as const;
export type StandbyApp = (typeof STANDBY_APPS)[number];

export const STANDBY_PLATFORMS = ['ios', 'android', 'web', 'phone'] as const;
export type StandbyPlatform = (typeof STANDBY_PLATFORMS)[number];

export const STANDBY_SURFACES = [
  'ios',
  'android',
  'mobile_web',
  'desktop_web',
  'widget',
  'branded_ios',
  'branded_android',
  'branded_web',
  'flex_ios',
  'flex_android',
  'flex_web',
  'phone_agent',
] as const;
export type StandbySurface = (typeof STANDBY_SURFACES)[number];

export const STANDBY_CORE_EVENTS = {
  ENTRY_CREATED: 'standby_entry_created',
  ENTRY_CREATE_SUBMITTED: 'standby_entry_create_submitted',
  ENTRY_CREATE_FAILED: 'standby_entry_create_failed',
  ENTRY_LEFT: 'standby_entry_left',
  ENTRY_REMOVED: 'standby_entry_removed',
} as const;
export type StandbyCoreEventName =
  (typeof STANDBY_CORE_EVENTS)[keyof typeof STANDBY_CORE_EVENTS];

export type StandbyAnalyticsSchema = {
  user_type: StandbyUserType;
  app: StandbyApp;
  platform: StandbyPlatform;
  surface: StandbySurface;
  app_version: string;
  entry_id?: string; // required on entry-scoped events
};
